import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { scrollTo, direct_admit_status } from '@modules/_misc';
import { HOME_PAGE_FAQS } from '@modules/react_content';
import { userActions } from '@reducers/user';
import Home from '@views/Public/shared-content/Home';
import withRouter from '@wrappers/withRouter';

const { VITE_ENV } = import.meta.env,
	_year = new Date().getFullYear();

const DirectAdmit = props => {
	const { navigate } = props,
		dispatch = useDispatch(),
		setDirectAdmit = () => dispatch(userActions.setDirectAdmit({ need_to_link: true })),
		da_status = useMemo(() => direct_admit_status(), []);

	useEffect(() => {
		scrollTo();
	}, []);

	return (
		<Home
			directAdmit={true}
			mainContent={
				<>
					<h1>
						Direct Admit <span>Wisconsin</span>
					</h1>

					{VITE_ENV !== 'production' && (
						<h2>{`${VITE_ENV === 'practice' ? 'Practice' : 'Development'} Application`}</h2>
					)}

					{da_status === 'closed' && (
						<h3 className='da-closed'>
							The deadline to accept your Direct Admit Wisconsin offer has passed.
						</h3>
					)}

					{da_status === 'closed' && (
						<p className='direct-admit-note'>
							While the deadline for accepting your Direct Admit admission has passed, you still have time
							to apply to attend a UW university. Please get started below.
						</p>
					)}

					{da_status === 'open-soon' ? (
						<p className='direct-admit-note'>
							Direct Admit Forms for students graduating high school in the Spring of {_year + 1} will be
							available August 1, {_year}.
						</p>
					) : (
						<div>
							<input
								type='button'
								onClick={() => {
									//da_status = direct_admit_status(); // in case of a stale render (?)

									if (da_status === 'open') setDirectAdmit();
									navigate('/create-account');
								}}
								className='btn-general primary'
								value='create account'
							/>

							<input
								type='button'
								onClick={() => {
									//da_status = direct_admit_status(); // in case of a stale render (?)

									if (da_status === 'open') setDirectAdmit();
									navigate('/sign-in');
								}}
								className='btn-general'
								value='sign in'
							/>
						</div>
					)}
				</>
			}
			faqs={HOME_PAGE_FAQS.direct_admit}
		/>
	);
};

export default withRouter(DirectAdmit);
